export async function getApiErrorDetail(
  response: Response,
  fallbackMessage: string
): Promise<string> {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    try {
      const data = await response.json() as { detail?: unknown; message?: unknown };
      if (typeof data.detail === 'string' && data.detail.trim()) {
        return data.detail;
      }
      if (typeof data.message === 'string' && data.message.trim()) {
        return data.message;
      }
    } catch {
      // Fall through to text parsing.
    }
  }

  try {
    const text = await response.text();
    if (text.trim()) {
      return text;
    }
  } catch {
    // Ignore parse failures and return the fallback.
  }

  return fallbackMessage;
}
